export default {
  common: {
    label: {
      accountNumber: 'Account number / Business name',
      weCouldNot: 'No Account found',
      noRecordsFound: 'No records found',
      noOptionsFound: 'No options found',
      expired: 'Expired',
      disabledOption: 'This option is currently disabled',
      loading: 'Loading ...',
    },
    placeholders: {
      accountNumber: 'Search for orders',
    },
    buttons: {
      next: 'Next',
      back: 'Back',
      backToHomepage: 'Back to homepage',
      cancel: 'Cancel',
      submit: 'Submit',
      save: 'Save',
      close: 'Close',
      clear: 'Clear',
      clickHere: 'click here',
      viewMore: 'View more',
      viewLess: 'View less',
    },
    errors: {
      required: 'This is a required field',
      divisionBy: '{{label}} is not divisible by {{denominator}}, try {{suggestedValue}}',
      isValidDate: '{{label}} should be a valid date',
      isFutureDate: '{{label}} should be a future date',
      isPastDate: '{{label}} should be a past date',
      maxDate: '{{label}} should be before {{maxDate}}',
      minDate: '{{label}} should be after {{minDate}}',
      minDateOr: '{{label}} should be after or {{minDate}}',
      maxDateOr: '{{label}} should be before or {{maxDate}}',
      isInvalidDate: 'Please re-enter a valid {{label}}',
      number: 'must be a valid number',
      integerNumber: 'This field must have a valid integer number',
      maxLength_one: 'Field must be at most one character',
      maxLength_other: 'Field must be at most {{count}} characters',
      greaterThanOrEqualTo: '{{label}} must be greater than or equal to {{value}}',
      requiredTreatments: 'This is a required field',
      maxDigitsAfterDecimal: '{{label}} must have at most {{count}} digits after the decimal point',
    },
    measureUnits: {
      tonne_one: 'tonne',
      tonne_other: 'tonnes',
      bag_one: 'bag',
      bag_other: 'bags',
    },
    envCropsPackages: {
      K25kg: '25kg',
      K20kg: '20kg',
      K5kg: '5kg',
      K500: '500kg',
      K10kg: '10kg',
      KAc50k: '50K seeds (acre)',
      KUNIT: '1 unit',
      KHECT5: '5kg (hectare)',
      'KHECT12.5': '12.5kg (hectare)',
      'K0.5HECT12.5': '12.5kg (0.5/half hectare)',
      K15kg: '15kg',
      KHECT25: '25kg (hectare)',
      KAc45k: '45K seeds (acre)',
      K2Ac100k: '100K seeds (two acres)',
      KHECT7: '7kg (hectare)',
      KHECT10: '10kg (hectare)',
      K300pl: '300 plants',
      K300each: '300 units',
      K25pl: '25 plants',
      K25each: '25 units',
    },
    envCropsPriceUOMLabels: {
      kg: 'kg',
      units: '£/unit',
      packs: '£/pack',
    },
    tooltips: {
      close: 'Close',
    },
    meta: {
      titles: {
        default: 'Digital Orders',
        fertiliser: 'Fertiliser',
        crop: 'Crop Protection',
        seed: 'Seed',
        'environmental-crops': 'Environmental Crops',
        'agronomy-agreement': 'Agronomy Agreement',
      },
    },
  },
  Header: {
    title: 'Digital Orders',
    subtitles: {
      fertiliser: 'Fertiliser',
      crop: 'Crop Protection',
      seed: 'Seed',
      'environmental-crops': 'Environmental Crops',
      'agronomy-agreement': 'Agronomy Agreement',
    },
  },
  HeaderMenu: {
    failedOrders: 'Failed Orders',
  },
  Customers: {
    groups: {
      mostUsed: 'Frequently used accounts',
      allCustomers: 'All accounts',
    },
  },
  OfflineNotification: {
    youAreOnline: 'You are back online.',
    youAreOffline: 'You’re currently offline. Some features may not be available.',
  },
  AccountRepresentatives: {
    labels: {
      representativeAccount: 'Representative code on sale',
      noOptions: 'No Accounts found',
    },
    placeholders: {
      representativeAccount: 'Search for representatives',
    },
  },
  ProductSelect: {
    labels: {
      product: 'Product',
      noOptions: 'No products found',
    },
    placeholders: {
      searchForProduct: 'Search for a product',
    },
    groups: {
      lastUsed: 'Last used products',
      limited: 'Products (up to {{maxNumberOfProductsPerSubgroup}})',
    },
  },
  FertProductSelect: {
    labels: {
      product: 'Product',
      noOptions: 'No products found',
    },
    placeholders: {
      searchForProduct: 'Search for a product',
    },
    groups: {
      lastUsed: 'Last used products',
      limited: 'Products (up to {{maxNumberOfProductsPerSubgroup}})',
    },
  },
  VirtualPackSelect: {
    labels: {
      product: 'Product',
      noOptions: 'No products found',
    },
    placeholders: {
      searchForVirtualPack: 'Search for a virtual pack',
    },
    groups: {
      virtualPacks: 'Virtual packs',
    },
  },
  CropProductTypes: {
    product: 'Product',
    virtualPack: 'Virtual pack',
  },
  Home: {
    title: 'Digital Orders',
    metaTitle: 'Digital Orders',
    welcomeText: 'Hello! How would you like to start?',
    chooseProductType: 'Please choose a product type:',
    rememberDecision: 'Remember my decision',
    continueBtn: 'Continue',
    fertiliserOption: 'Fertiliser',
    cropProtectionOption: 'Crop Protection',
    seedOption: 'Seed',
    environmentalCropsOption: 'Environmental Crops',
    agronomyAgreementOption: 'Agronomy Agreement',
  },
  FertiliserHome: {
    title: 'Fertiliser',
    metaTitle: 'Fertiliser',
    orSeparator: 'Or',
    buttons: { createOrder: 'Create new order' },
    labels: { disabledOption: 'This option is currently disabled' },
    resetProductType: 'Choose product type',
  },
  CropProtectionHome: {
    title: 'Crop Protection',
    metaTitle: 'Crop Protection',
    orSeparator: 'Or',
    buttons: { createOrder: 'Create new order' },
    labels: { disabledOption: 'This option is currently disabled' },
    resetProductType: 'Choose product type',
  },
  SeedHome: {
    title: 'Seed',
    metaTitle: 'Seed',
    orSeparator: 'Or',
    buttons: { createOrder: 'Create new order' },
    labels: { disabledOption: 'This option is currently disabled' },
    resetProductType: 'Choose product type',
  },
  EnvironmentalCropsHome: {
    title: 'Environmental Crops',
    metaTitle: 'Environmental Crops',
    orSeparator: 'Or',
    buttons: { createOrder: 'Create new order' },
    labels: { disabledOption: 'This option is currently disabled' },
    resetProductType: 'Choose product type',
  },
  AgronomyAgreementHome: {
    title: 'Agronomy Agreement',
    metaTitle: 'Agronomy Agreement',
    orSeparator: 'Or',
    buttons: {
      createAgreement: 'Create new agreement',
      downloadBlankAgreement: 'Download blank agreement',
    },
    searchPlaceholder: 'Search for agreements',
    resetProductType: 'Choose product type',
  },
  CreateOrder: {
    subHeaderTitles: {
      customer: 'New order - Customer details',
      products: 'Order products',
      delivery: 'Delivery details',
      summary: 'Order summary',
    },
    buttons: {
      submitOrder: 'Submit order',
    },
    dialogs: {
      backToHomepage: {
        buttonPrimary: 'Back to homepage',
        title: 'Action not possible',
        description:
          'There are no pre-selected customers in the list. Please add more customers once you’re back online. ',
      },
      accountChange: {
        title: 'Account change',
        description:
          'Are you sure you want to change/remove the account? Doing so will reset your progress and remove your existing products from the basket. Confirm change?',
        buttonPrimary: 'Confirm',
      },
      officeLocationChange: {
        title: 'Office location change',
        description:
          'Are you sure you want to change the office location? If there are any existing products in the basket they will need to be re-added or updated. Confirm change?',
        buttonPrimary: 'Confirm',
      },
      unsavedChanges: {
        title: 'Unsaved changes',
        description:
          'You are about to leave this page. Your current progress will not be saved. Are you sure you want to continue?',
        buttonPrimary: 'Yes, leave',
      },
    },
    labels: {
      products: 'Products',
    },
    errors: {
      unableToCreateOrder: 'There was an error submitting the order. Please try again.',
      noOrdersFound: 'No such order was found!',
    },
    tabs: {
      addProduct: 'Add product',
      viewBasket: 'View basket',
    },
    viewBasket: {
      card: {
        productQuantity: 'Quantity (tonnes):',
        editBtn: 'Edit',
        deleteBtn: 'Remove',
        noProducts: 'Your basket is empty!',
        bagSize: 'Bag Size:',
      },
      dialog: {
        title: 'Edit product',
        cancelBtn: 'Cancel',
        saveBtn: 'Save changes',
      },
      deleteDialog: {
        title: 'Product removal',
        actionBtn: 'Remove',
        message: 'Are you sure you want to remove this product from your basket?',
      },
    },
    CustomerDetails: {
      labels: {
        customer: 'Account number',
        officeLocation: 'Office location',
        accountName: 'Business name',
        notes: 'Notes (optional)',
        multiAccount: 'Multiple account (optional)',
        accountNumber: 'Account number / Business name',
        representativeAccount: 'Representative code on sale',
      },
      placeholders: {
        officeLocation: 'Select location',
        accountName: 'No data',
        notes: 'Write customer related notes here...',
        multiAccount: 'Select multiple account',
        accountNumber: 'Search for accounts',
        startDate: 'Add date',
        endDate: 'Add date',
      },
      notifications: {
        multiOff: {
          title: 'Multiple account is NOT SELECTED',
          description:
            'Payment terms ARE REQUIRED on the next step. Please, make sure to update any existing products from the basket.',
        },
        multiOntrue: {
          title: 'Multiple account is SELECTED',
          description: 'Payment terms ARE NOT REQUIRED on the next step.',
        },
        multiOnfalse: {
          title: 'Multiple account is SELECTED',
          description: '',
        },
      },
    },
    ProductForm: {
      labels: {
        paymentTerms: 'Payment terms',
        paymentDue: 'Payment due',
        price: 'Product price',
        bulkQuantity: 'Quantity (tonnes)',
        productName: 'Product',
        notes: 'Notes (optional)',
        businessName: 'Business user name',
        businessContact: 'Business user contact number',
        startDate: 'Start date',
        endDate: 'End date',
        startDateDEL: 'Delivery start date',
        startDateCOL: 'Collection start date',
        endDateDEL: 'Delivery end date',
        endDateCOL: 'Collection end date',
        transportMethod: 'Transport method',
        deliveryAddress: 'Address',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        noAddressesFound: 'No addresses found',
        bagSize: 'Bag size',
      },
      placeholders: {
        price: 'Insert price',
        paymentTerms: 'Select payment',
        paymentDue: 'Select date',
        bulkQuantity: 'Insert quantity',
        productName: 'Select a product',
        notes: 'Write notes here...',
        businessName: 'Add name',
        businessContact: 'Add contact number',
        startDate: 'Add date',
        endDate: 'Add date',
        transportMethod: 'Select a transport method',
        deliveryAddress: 'Select address',
        bagSize: 'Select a bag size',
      },
      buttons: {
        addToBasket: 'Add to basket',
      },
      notifications: {
        productWasAdded: 'Product was added successfully to the basket',
        productWasUpdated: 'Your product was updated successfully',
      },
    },
    DeliveryDetails: {
      labels: {
        startDate: 'Start date',
        endDate: 'End date',
        transportMethod: 'Transport method',
        deliveryAddress: 'Address',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        noAddressesFound: 'No addresses found',
        deliveryNotes: 'Notes (optional)',
      },
      placeholders: {
        startDate: 'Select a starting date',
        endDate: 'Select an end date',
        transportMethod: 'Select a transport method',
        deliveryAddress: 'Select address',
        deliveryNotes: 'Write delivery related notes here...',
      },
    }, // TODO: Remove after cleanup
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        productDetails: 'Product details',
        orderDetails: 'Order details',
        repDetails: 'Representative details',
        deliveryDetails: 'Delivery details',
        orderNumber: 'Order #',
      },
      fields: {
        customer: 'Account number',
        accountName: 'Business name',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        multiAccount: 'Multiple account',
        officeLocation: 'Office location',
        customerNotes: 'Notes (optional)',
        deliveryNotes: 'Notes (optional)',
        paymentTerms: 'Payment terms',
        paymentDue: 'Payment due',
        price: 'Price',
        productDescription: 'Bag size/Weight',
        bulkQuantity: 'Quantity (tonnes)',
        productName: 'Product',
        productNotes: 'Notes (optional)',
        startDate: 'Start date',
        endDate: 'End date',
        transportMethod: 'Transport method',
        deliveryAddress: 'Delivery address',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        deliveryEndDate: 'Delivery End date',
        deliveryStartDate: 'Delivery Start date',
        businessName: 'Business user name',
        businessContact: 'Business user contact number',
      },
      notifications: {
        orderNotConfirmed:
          'This order is not yet authorised. You may be contacted if there are any queries.',
      },
    },
  },
  CreateCropOrder: {
    subHeaderTitles: {
      customer: 'New order - Customer details',
      products: 'Order products',
      summary: 'Order summary',
    },
    buttons: {
      submitOrder: 'Submit order',
    },
    dialogs: {
      unsavedChanges: {
        title: 'Unsaved changes',
        description:
          'You are about to leave this page. Your current progress will not be saved. Are you sure you want to continue?',
        buttonPrimary: 'Yes, leave',
      },
    },
    tabs: {
      addProduct: 'Add product',
      viewBasket: 'View basket',
    },
    labels: {
      products: 'Products',
    },
    errors: {
      unableToCreateOrder: 'There was an error submitting the order. Please try again.',
    },
    CustomerDetails: {
      labels: {
        accountNumber: 'Account number / Business name',
        multiAccount: 'Multiple account',
        representativeAccount: 'Representative code on sale',
        officeLocation: 'Office location',
        notes: 'Notes (optional)',
        transportMethod: 'Transport method',
        dateDEL: 'Delivery date',
        dateCOL: 'Collection date',
        deliveryDate: 'Date',
        deliveryAddress: 'Address',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        noAddressesFound: 'No addresses found',
      },
      placeholders: {
        accountNumber: 'Search for accounts',
        multiAccount: 'Select multiple account',
        officeLocation: 'Select location',
        notes: 'Write customer related notes here...',
        transportMethod: 'Select a transport method',
        deliveryAddress: 'Select address',
      },
      dialogs: {
        accountChange: {
          title: 'Account change',
          description:
            'Are you sure you want to change/remove the account? Doing so will reset your progress and remove your existing products from the basket. Confirm change?',
          buttonPrimary: 'Confirm',
        },
      },
    },
    ProductForm: {
      labels: {
        productType: 'Product type',
        product: 'Product',
        packNumber: 'Number of packs',
        quantity: 'Quantity',
      },
      placeholders: {
        productType: 'Select a type',
        product: 'Select a product',
        packNumber: 'Insert number',
        quantity: 'Insert number',
      },
      notifications: {
        productWasAdded: 'Product was added successfully to the basket',
      },
      buttons: {
        addToBasket: 'Add to basket',
      },
      errors: {
        maxNumberOfPacks: 'Limit reached! Maximum number of packs cannot exceed: {{maxLimit}}',
      },
    },
    viewBasket: {
      card: {
        productType: 'Product type',
        referenceCode: 'Reference code',
        contains: 'Contains',
        quantity: 'Quantity',
        numberOfPacks: 'Number of packs',
        deleteBtn: 'Remove',
        noProducts: 'Your basket is empty!',
      },
      deleteDialog: {
        title: 'Product removal',
        actionBtn: 'Remove',
        message: 'Are you sure you want to remove this product from your basket?',
      },
    },
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        orderDetails: 'Order details',
      },
      fields: {
        customer: 'Account number',
        accountName: 'Business name',
        multiAccount: 'Multiple account',
        officeLocation: 'Office location',
        transportMethod: 'Transport method',
        deliveryDateDEL: 'Delivery date',
        deliveryDateCOL: 'Collection date',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        customerNotes: 'Notes (optional)',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        productType: 'Product type',
        referenceCode: 'Reference code',
        packSize: 'Pack size',
        packNumber: 'Number of packs',
        quantity: 'Quantity',
        product: 'Product',
      },
    },
  },
  CreateSeedOrder: {
    subHeaderTitles: {
      customer: 'New order - Customer details',
      products: 'Order products',
      summary: 'Order summary',
    },
    buttons: {
      submitOrder: 'Submit order',
    },
    dialogs: {
      unsavedChanges: {
        title: 'Unsaved changes',
        description:
          'You are about to leave this page. Your current progress will not be saved. Are you sure you want to continue?',
        buttonPrimary: 'Yes, leave',
      },
    },
    labels: {
      products: 'Products',
    },
    tabs: {
      addProduct: 'Add product',
      viewBasket: 'View basket',
    },
    errors: {
      unableToCreateOrder: 'There was an error submitting the order. Please try again.',
    },
    CustomerDetails: {
      labels: {
        accountNumber: 'Account number / Business name',
        multiAccount: 'Multiple account (optional)',
        representativeAccount: 'Representative code on sale',
        notes: 'Haulage notes (optional)',
        transportMethod: 'Transport method',
        deliveryAddress: 'Address',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        noAddressesFound: 'No addresses found',
        customerOrderNumber: 'Customer order number (optional)',
        season: 'Trading season',
      },
      placeholders: {
        accountNumber: 'Search for accounts',
        multiAccount: 'Select multiple account',
        notes: 'Write notes here e.g. no ARTIC',
        transportMethod: 'Select a transport method',
        deliveryAddress: 'Select address',
        customerOrderNumber: 'Insert reference',
        season: 'Select a season',
      },
      notifications: {
        multiOff: {
          title: 'Multiple account is NOT SELECTED',
          description:
            'Payment terms ARE REQUIRED on the next step. Please, make sure to update any existing products from the basket.',
        },
        multiOntrue: {
          title: 'Multiple account is SELECTED',
          description: 'Payment terms ARE NOT REQUIRED on the next step.',
        },
        multiOnfalse: {
          title: 'Multiple account is SELECTED',
          description: '',
        },
      },
    },
    ViewBasket: {
      card: {
        seedType: 'Seed type',
        crop: 'Crop',
        defaultTreatment_one: 'Default treatment',
        defaultTreatment_other: 'Default treatments',
        additionalTreatment_one: 'Additional treatment',
        additionalTreatment_other: 'Additional treatments',
        bagSize: 'Bag size',
        bagSizes: {
          TBA1: '1000KG',
          TBA5: '500KG',
        },
        packs: 'Number of packs',
        quantity: 'Quantity{{type}}',
        deleteBtn: 'Remove',
        editBtn: 'Edit',
        noProducts: 'Your basket is empty!',
      },
      dialog: {
        title: 'Edit product',
        cancelBtn: 'Cancel',
        saveBtn: 'Save changes',
      },
      deleteDialog: {
        title: 'Product removal',
        actionBtn: 'Remove',
        message: 'Are you sure you want to remove this product from your basket?',
      },
      notifications: {
        productWasUpdated: 'Your product was updated successfully',
      },
    },
    ProductForm: {
      buttons: {
        addToBasket: 'Add to basket',
      },
      labels: {
        seedType: 'Seed type',
        crop: 'Crop',
        variety: 'Variety',
        unitPrice: 'Unit price (optional)',
        unitPriceValidation: 'Unit price',
        packs: 'Number of packs',
        bagSize: 'Bag size',
        bagSizes: {
          TBA1: '1000KG',
          TBA5: '500KG',
        },
        quantity: 'Quantity{{type}}',
        tgwNotAvailable: 'TGW Calculator is not available for this product',
        quantityValidation: 'Quantity',
        paymentTerms: 'Payment terms',
        paymentDueDate: 'Payment due',
        businessName: 'Business user name',
        businessContact: 'Business user contact number',
        treatments: 'Treatments *',
        treatment_default_one: 'Default treatment',
        treatment_default_other: 'Default treatments',
        treatment_additional_one: 'Additional treatment',
        treatment_additional_other: 'Additional treatments',
        notes: 'Notes (optional)',
      },
      placeholders: {
        crop: 'Search for a crop',
        unitPrice: 'Insert price',
        packs: 'Insert number',
        variety: 'Search for a variety',
        bagSize: 'Select bag size',
        quantity: 'Insert or use TGW calculator',
        paymentTerms: 'Select payment',
        businessName: 'Add name',
        businessContact: 'Add contact number',
        treatments: 'Select treatment',
        notes: 'Write notes here',
      },
      noOptionsText: {
        crop: 'No results found',
        variety: 'No results found',
      },
      notifications: {
        productWasAdded: 'Product was added successfully to the basket',
      },
    },
    TgwModal: {
      title: 'TGW calculator',
      close: 'Close',
      apply: 'Apply quantity',
      validationLabels: {
        area: 'Area',
        seedNumber: 'Seed number',
        germination: 'Germination',
        tgw: 'TGW',
      },
      labels: {
        area: 'Area ({{unitLabel}})',
        seedNumber: 'Seed number ({{unitLabel}})',
        tgw: 'Thousand Grain Weight (TGW)',
        germination: 'Germination %',
        seedRequired: 'Seed required (mt)',
        seedRate: 'Seed rate (kg/{{unitLabel}})',
      },
      placeholders: {
        area: 'Insert area',
        seedNumber: 'Insert number',
        tgw: 'Insert weight',
        germination: 'Insert number',
        seedRequired: '--',
        seedRate: '--',
      },
    },
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        orderDetails: 'Order details',
      },
      fields: {
        accountName: 'Business name',
        customer: 'Account number',
        season: 'Trading season',
        multiAccount: 'Multiple account',
        transportMethod: 'Transport method',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        customerOrderNumber: 'Customer order number (optional)',
        customerNotes: 'Haulage Notes (optional)',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        createdBy: 'Order created by',
        createdByEmail: 'E-mail',
        crop: 'Crop',
        variety: 'Variety',
        unitPrice: 'Unit price (optional)',
        unitPriceValidation: 'Unit price',
        packs: 'Number of packs',
        bagSize: 'Bag size',
        bagSizes: {
          TBA1: '1000KG',
          TBA5: '500KG',
        },
        quantity: 'Quantity{{type}}',
        quantityValidation: 'Quantity',
        paymentTerms: 'Payment terms',
        paymentDueDate: 'Payment due',
        businessName: 'Business user name',
        businessContact: 'Business user contact number',
        treatment_one: 'Treatment',
        treatment_other: 'Treatments',
        treatment_additional_one: 'Additional treatment (optional)',
        treatment_additional_other: 'Additional treatments (optional)',
        notes: 'Notes (optional)',
        seedType: 'Seed type',
      },
      notifications: {
        orderNotConfirmed:
          'This order is not yet authorised. You may be contacted if there are any queries.',
      },
    },
  },
  CreateEnvironmentalCropsOrder: {
    subHeaderTitles: {
      customer: 'New order - Customer details',
      products: 'Order products',
      summary: 'Order summary',
    },
    buttons: {
      submitOrder: 'Submit order',
    },
    dialogs: {
      unsavedChanges: {
        title: 'Unsaved changes',
        description:
          'You are about to leave this page. Your current progress will not be saved. Are you sure you want to continue?',
        buttonPrimary: 'Yes, leave',
      },
    },
    labels: {
      products: 'Products',
    },
    tabs: {
      addProduct: 'Add product',
      viewBasket: 'View basket',
    },
    errors: {
      unableToCreateOrder: 'There was an error submitting the order. Please try again.',
    },
    CustomerDetails: {
      labels: {
        accountNumber: 'Account number / Business name',
        multiAccount: 'Multiple account (optional)',
        representativeAccount: 'Representative code on sale',
        notes: 'Haulage notes (optional)',

        deliveryAddress: 'Delivery address',

        noAddressesFound: 'No addresses found',
        customerOrderNumber: 'Customer order number (optional)',
        adminNotes: 'Admin notes (optional)',
      },
      placeholders: {
        accountNumber: 'Search for accounts',
        multiAccount: 'Select multiple account',
        representativeAccount: 'Search for representatives',
        notes: 'Write notes here',
        deliveryAddress: 'Select address',
        customerOrderNumber: 'Insert customer order number',
        adminNotes: 'Write notes here',
      },
    },
    ProductForm: {
      labels: {
        seedType: 'Seed type',
        product: 'Product',
        package: 'Package',
        treatments: 'Treatments',
        priceUOM: 'Price UOM',
        quantity: 'Quantity',
        quantity_type: 'Quantity ({{type}})',
        quantityValidation: 'Quantity',
        packsValidation: 'No. packs',
        packs: 'No. packs',
        unitPrice: 'Unit price',
        deliveryFrom: 'Delivery from',
        deliveryTo: 'Delivery to',
        startDate: 'Start date',
        endDate: 'End date',
      },
      placeholders: {
        product: 'Search for a product',
        package: 'Select package size',
        treatments: 'No treatments present',
        quantity: 'Insert number',
        packs: 'Insert number',
        priceUOM: 'No package selected',
        unitPrice: 'No package selected',
        noUnitPrice: 'Insert price',
      },
      noOptionsText: {
        product: 'No products found',
        package: 'No package sizes found',
      },
      addProduct: 'Add to basket',
      notifications: {
        productWasAdded: 'Product was added successfully to the basket',
      },
    },
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        orderDetails: 'Order details',
      },
      fields: {
        customer: 'Account number',
        accountName: 'Business name',
        multiAccount: 'Multiple account',
        deliveryAddress: 'Delivery address',
        customerOrderNumber: 'Customer order number',
        customerNotes: 'Haulage notes (optional)',
        adminNotes: 'Admin notes (optional)',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        seedType: 'Seed type',
        product: 'Product',
        package: 'Package',
        treatments: 'Treatments',
        quantity: 'Quantity{{type}}',
        packs: 'No. packs',
        deliveryFrom: 'Delivery from',
        deliveryTo: 'Delivery to',
        location: 'Location',
        unitPrice: 'Unit price',
        totalPrice: 'Total price',
        createdBy: 'Order created by',
        createdByEmail: 'E-mail',
      },
      notifications: {
        orderNotConfirmed:
          'This order is not yet authorised. You may be contacted if there are any queries.',
      },
    },
    viewBasket: {
      card: {
        itemReference: 'Reference code',
        quantity: 'Quantity{{type}}',
        packs: 'No. packs',
        unitPrice: 'Unit price',
        totalPrice: 'Total price',
        editBtn: 'Edit',
        deleteBtn: 'Remove',
        noProducts: 'Your basket is empty!',
      },
      deleteDialog: {
        title: 'Product removal',
        actionBtn: 'Remove',
        message: 'Are you sure you want to remove this product from your basket?',
      },
      editProductDialog: {
        title: 'Edit product',
        cancelBtn: 'Cancel',
        saveBtn: 'Save changes',
      },
    },
  },
  CreateAgronomyAgreement: {
    subHeaderTitles: {
      customer: 'New agreement - Customer details',
      products: 'Add crops',
      additional: 'Additional products & services',
      summary: 'Agreement summary',
    },
    buttons: {
      submit: 'Submit agreement',
    },
    dialogs: {
      unsavedChanges: {
        title: 'Unsaved changes',
        description:
          'You are about to leave this page. Your current progress will not be saved. Are you sure you want to continue?',
        buttonPrimary: 'Yes, leave',
      },
    },
    tabs: {
      addProduct: 'Add product',
      viewBasket: 'View basket',
    },
    CustomerDetails: {
      labels: {
        accountNumber: 'Account number / Business name',
        representativeAccount: 'Representative code on agreement',
        startDate: 'Agreement start date',
        endDate: 'Agreement end date',
        loyaltyTier: 'Customer loyalty tier',
        paymentTerms: 'Payment terms',
        notes: 'Notes (optional)',
        multiAccount: 'Multiple account (optional)',
      },
      placeholders: {
        accountNumber: 'Search for accounts',
        representativeAccount: 'Search for representatives',
        startDate: 'Add date',
        endDate: 'Add date',
        notes: 'Write notes here',
        multiAccount: 'Select multiple account',
      },
      errors: {
        required: 'This field is required',
        invalidDate: 'Invalid date entered. Please try again',
        minStartDate: 'Start date cannot be more than 30 days in the past',
        maxStartDate: 'Start date cannot be more than 12 months in the future',
        minEndDate: 'End date must be later than start date',
        maxEndDate: 'End date cannot be more than 2 years after the start date',
      },
    },
  },
  ViewCropOrder: {
    subtitle: {
      noOrdersFound: 'No order was found for this account!',
      id: 'ID:',
      status: 'Status:',
      open: 'Open',
      draft: 'Draft',
      error: 'Failed',
    },
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        orderDetails: 'Order details',
      },
      fields: {
        customer: 'Account number',
        accountName: 'Business name',
        multiAccount: 'Multiple account',
        officeLocation: 'Office location',
        transportMethod: 'Transport method',
        deliveryDateDEL: 'Delivery date',
        deliveryDateCOL: 'Collection date',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        customerNotes: 'Notes (optional)',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        createdBy: 'Order created by',
        createdByEmail: 'E-mail',
        productType: 'Product type',
        referenceCode: 'Reference code',
        packSize: 'Pack size',
        packNumber: 'Number of packs',
        quantity: 'Quantity',
        product: 'Product',
      },
      notifications: {
        orderFailed: 'An error occurred while sending one of your orders.',
        orderNotPlaced:
          'Unfortunately, your order has not been placed. Please contact your administrator for further details.',
      },
    },
  },
  ViewOrder: {
    subtitle: {
      id: 'ID:',
      status: 'Status:',
      open: 'Open',
      draft: 'Draft',
      error: 'Failed',
      closed: 'Closed',
      noOrdersFound: 'No order was found for this account!',
    },
    statusErrorMessage:
      'Unfortunately, it is not possible to submit your order, please contact your admin team',
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        orderDetails: 'Order details',
        repDetails: 'Representative details',
        deliveryDetails: 'Delivery details',
        productDetails: 'Product details',
        orderNumber: 'Order #',
      },
      fields: {
        customer: 'Account number',
        accountName: 'Business name',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        multiAccount: 'Multiple account',
        officeLocation: 'Office location',
        customerNotes: 'Notes (optional)',
        deliveryNotes: 'Notes (optional)',
        paymentTerms: 'Payment terms',
        paymentDue: 'Payment due',
        price: 'Price',
        productDescription: 'Bag size/Weight',
        bulkQuantity: 'Quantity (tonnes)',
        productName: 'Product',
        productNotes: 'Notes (optional)',
        startDate: 'Start date',
        endDate: 'End date',
        transportMethod: 'Transport method',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        createdBy: 'Order created by',
        createdByEmail: 'E-mail',
        businessName: 'Business user name',
        businessContact: 'Business user contact number',
      },
      notifications: {
        orderFailed:
          'An error occurred while sending one of your orders. Try resending it from the <linkToPage>Failed orders</linkToPage> list',
        orderNotConfirmed:
          'This order is not yet authorised. The process will take one business day to complete.',
        orderNotPlaced:
          'Unfortunately, your order has not been placed. Please contact your administrator for further details.',
      },
    },
  },
  ViewSeedOrder: {
    subtitle: {
      id: 'ID:',
      status: 'Status:',
      open: 'Open',
      draft: 'Draft',
      error: 'Failed',
      closed: 'Closed',
      noOrdersFound: 'No order was found for this account!',
    },
    statusErrorMessage:
      'Unfortunately, it is not possible to submit your order, please contact your admin team',
    OrderSummary: {
      accordions: {
        customerDetails: 'Customer details',
        orderDetails: 'Order details',
        orderNumber: 'Order #',
      },
      fields: {
        accountName: 'Business name',
        customer: 'Account number',
        season: 'Trading season',
        multiAccount: 'Multiple account',
        transportMethod: 'Transport method',
        deliveryAddressDEL: 'Delivery address',
        deliveryAddressCOL: 'Collection address',
        customerOrderNumber: 'Customer order number (optional)',
        customerNotes: 'Haulage Notes (optional)',
        accountRepresentativeName: 'Representative name',
        accountRepresentativeCode: 'Representative code on sale',
        accountRepresentativeEmail: 'Representative e-mail',
        createdBy: 'Order created by',
        createdByEmail: 'E-mail',
        crop: 'Crop',
        variety: 'Variety',
        unitPrice: 'Unit price (optional)',
        unitPriceValidation: 'Unit price',
        packs: 'Number of packs',
        bagSize: 'Bag size',
        bagSizes: {
          TBA1: '1000KG',
          TBA5: '500KG',
        },
        quantity: 'Quantity{{type}}',
        quantityValidation: 'Quantity',
        paymentTerms: 'Payment terms',
        paymentDueDate: 'Payment due',
        businessName: 'Business user name',
        businessContact: 'Business user contact number',
        treatment_one: 'Treatment',
        treatment_other: 'Treatments',
        treatment_additional_one: 'Additional treatment (optional)',
        treatment_additional_other: 'Additional treatments (optional)',

        seedType: 'Seed type',
      },
      notifications: {
        orderFailed:
          'An error occurred while sending one of your orders. Try resending it from the <linkToPage>Failed orders</linkToPage> list',
        orderNotConfirmed:
          'This order is not yet authorised. The process will take one business day to complete.',
        orderNotPlaced:
          'Unfortunately, your order has not been placed. Please contact your administrator for further details.',
      },
    },
  },
  ViewEnvironmentalCropsOrder: {
    subtitle: {
      id: 'ID:',
      status: 'Status:',
      open: 'Open',
      draft: 'Draft',
      error: 'Failed',
      closed: 'Closed',
      noOrdersFound: 'No order was found for this account!',
    },
    OrderSummary: {
      accordions: {
        orderNumber: 'Order #',
      },
      notifications: {
        orderFailed:
          'An error occurred while sending one of your orders. Try resending it from the <linkToPage>Failed orders</linkToPage> list',
        orderNotConfirmed:
          'This order is not yet authorised. The process will take {{processingTime}} hours to complete.',
        orderNotPlaced:
          'Unfortunately, your order has not been placed. Please contact Environmental Crops at {{contactEmail}} to resolve issues regarding error messages',
      },
    },
  },

  NotFound: {
    title: 'Page not found',
    subtitle: 'The page you were looking for could not be found. Please go back to the home page.',
    goBackButton: 'Go back to homepage',
  },
  FailedOrders: {
    title: 'Failed orders',
    columns: {
      date: 'Created on',
      customerReference: 'Account number',
      customerName: 'Business name',
      error: 'Error message',
      resendStatus: 'Status',
      actions: 'Actions',
      product: 'Product',
      quantity: 'Quantity',
      price: 'Price',
    },
    deleteDialog: {
      title: 'Delete order',
      actionBtn: 'Yes, delete',
      closeLabel: 'Cancel',
      message: 'Are you sure you want to delete the current order?',
    },
    tooltips: {
      deleteOrder: 'Delete',
      resendOrder: 'Resend',
    },
    buttons: {
      resend: 'Resend',
      delete: 'Delete',
    },
    notification: 'Please contact the Admin team to resolve issues regarding error messages',
    emptyOrdersListTable: 'No orders found',
    errors: {
      unableToDeleteOrder: 'Unable to delete the selected order.',
      unableToResendOrder: 'There was an error while re-sending the order. Please try again',
    },
    success: {
      deleteOrder: 'Your order was deleted successfully.',
      resendOrder: 'Your order was re-sent successfully',
    },
    statusChip: {
      error: 'Error',
      pending: 'Resending...',
    },
  },

  CropFailedOrders: {
    title: 'Failed orders',
    columns: {
      date: 'Created on',
      customerReference: 'Account number',
      customerName: 'Business name',
      error: 'Error message',
      resendStatus: 'Status',
      actions: 'Actions',
      productType: 'Product type',
      product: 'Product',
      referenceNumber: 'Reference number',
      numberOfPacks: 'Number of packs',
    },
    deleteDialog: {
      title: 'Delete order',
      actionBtn: 'Yes, delete',
      closeLabel: 'Cancel',
      message: 'Are you sure you want to delete the current order?',
    },
    tooltips: {
      deleteOrder: 'Delete',
      resendOrder: 'Resend',
    },
    buttons: {
      resend: 'Resend',
      delete: 'Delete',
      viewMore_one: 'View more ({{count}} product)',
      viewMore_other: 'View more ({{count}} products)',
      viewLess: 'View less',
    },
    notification: 'Please contact the Admin team to resolve issues regarding error messages',
    emptyOrdersListTable: 'No orders found',
    errors: {
      unableToDeleteOrder: 'Unable to delete the selected order.',
      unableToResendOrder: 'There was an error while re-sending the order. Please try again',
    },
    success: {
      deleteOrder: 'Your order was deleted successfully.',
      resendOrder: 'Your order was re-sent successfully',
    },
    statusChip: {
      error: 'Error',
      pending: 'Resending...',
    },
  },
  SeedFailedOrders: {
    title: 'Failed orders',
    columns: {
      date: 'Created on',
      customerReference: 'Account number',
      customerName: 'Business name',
      error: 'Error message',
      resendStatus: 'Status',
      actions: 'Actions',
      variety: 'Variety',
      packs: 'Number of packs',
      bagSize: 'Bag size',
      bagSizes: {
        TBA1: '1000KG',
        TBA5: '500KG',
      },
    },
    deleteDialog: {
      title: 'Delete order',
      actionBtn: 'Yes, delete',
      closeLabel: 'Cancel',
      message: 'Are you sure you want to delete the current order?',
    },
    tooltips: {
      deleteOrder: 'Delete',
      resendOrder: 'Resend',
    },
    buttons: {
      resend: 'Resend',
      delete: 'Delete',
      viewMore_one: 'View more ({{count}} product)',
      viewMore_other: 'View more ({{count}} products)',
      viewLess: 'View less',
    },
    notification: 'Please contact the Admin team to resolve issues regarding error messages',
    emptyOrdersListTable: 'No orders found',
    errors: {
      unableToDeleteOrder: 'Unable to delete the selected order.',
      unableToResendOrder: 'There was an error while re-sending the order. Please try again',
    },
    success: {
      deleteOrder: 'Your order was deleted successfully.',
      resendOrder: 'Your order was re-sent successfully',
    },
    statusChip: {
      error: 'Error',
      pending: 'Resending...',
    },
  },
  EnvCropsFailedOrders: {
    title: 'Failed orders',
    columns: {
      date: 'Created on',
      customerReference: 'Account number',
      customerName: 'Business name',
      error: 'Error message',
      resendStatus: 'Status',
      actions: 'Actions',
      itemDescription: 'Product',
      location: 'Location',
      packageReference: 'Package',
      quantity: 'Quantity',
      packs: 'Number of packs',
      total: 'Total price',
    },
    deleteDialog: {
      title: 'Delete order',
      actionBtn: 'Yes, delete',
      closeLabel: 'Cancel',
      message: 'Are you sure you want to delete the current order?',
    },
    tooltips: {
      deleteOrder: 'Delete',
      resendOrder: 'Resend',
    },
    buttons: {
      resend: 'Resend',
      delete: 'Delete',
      viewMore_one: 'View more ({{count}} product)',
      viewMore_other: 'View more ({{count}} products)',
      viewLess: 'View less',
    },
    notification:
      'Please contact Environmental Crops at <email>{{contactEmail}}</email> to resolve issues regarding error messages.',
    emptyOrdersListTable: 'No orders found',
    errors: {
      unableToDeleteOrder: 'There was an error deleting this order. Please try again.',
      unableToResendOrder: 'There was an error while re-sending the order. Please try again',
    },
    success: {
      deleteOrder: 'Your order was deleted successfully.',
      resendOrder: 'Your order was re-sent successfully',
    },
    statusChip: {
      error: 'Error',
      pending: 'Resending...',
    },
  },

  LoginRedirect: {
    expirationMessage:
      'Credentials expired. You will be redirected to the login page in {{timer}} seconds, please wait...',
    ctaMessage: "If you haven't been redirected, please click this button.",
    ctaLabel: 'Continue',
  },
  RedirectNotAllowed: {
    message:
      'You do not have access to Digital Orders. You will be redirected to the login page in {{timer}} seconds, please wait...',
    ctaMessage: "If you haven't been redirected, please click this button.",
    ctaLabel: 'Continue',
  },
  ProductSubgroup: {
    label: 'Product subgroup',
    placeholder: 'All',
    noOptions: 'No subgroups found',
  },
  ActionRequired: {
    dialog: {
      title_photoID: 'Photo ID verification required',
      title_limusPerform: 'Limus Perform required',
      title_multi: 'Action required',
      subtitle_photoID: '{{index}}. $t(ActionRequired:dialog.title_photoID)',
      subtitle_limusPerform: '{{index}}. $t(ActionRequired:dialog.title_limusPerform)',
      description_photoID:
        'Photo ID is required for the listed product(s) and has not yet been provided. Please contact the customer to resolve this issue.',
      description_limusPerform:
        'Limus Perform is required to be used with the following product(s) between dates {{startDate}} and {{endDate}}. Please contact the customer to remind them of this regulation.',
      confirmBtn: 'I understand',
      sendEmailLinkPrompt:
        'Please use the link below to email the customer a secure link to the upload page:',
      sendEmailLink: 'Send email link',
      emailStatus_sent: 'Email link sent to customer successfully.',
      emailStatus_noMyFarm:
        'Customer does not have MyFarm access. Customer Service has been notified to assist with the account setup.',
      emailStatus_alreadySent: 'A Photo ID request has already been sent for this customer.',
      emailStatus_error: 'Email could not be sent. Please try again.',
    },
  },
  RootErrorBoundary: {
    errorMessage: 'Something went wrong. Please refresh the page and try again.',
    ctaLabel: 'Reload page',
  },
};
